import React from 'react';
import {I18N} from '../../globals/config';

import styles from './item.pcss';
import historyStyles from '../history.pcss';
import {HistoryItem} from '../History';
import {setState} from '../../globals/state';

type Props = {
	item: HistoryItem
	closeModal: () => void;
}

const Item = ( {item, closeModal}: Props ) => {
	return (
		<div className={styles.wrap} data-jest={'wrap'}>
			<div className={historyStyles.old} data-jest={'old'}>
				{item.old}
			</div>
			<div className={historyStyles.new} data-jest={'new'}>
				{item.new}
			</div>
			<div className={historyStyles.date}>
				{item.date}
			</div>
			<div className={historyStyles.action}>
				<button
					className="button-primary"
					title={I18N.use_this_history}
					onClick={() => {
						setState( {
							oldUrl: item.old,
							newUrl: item.new,
						} );
						closeModal();
					}}>
					{I18N.use}
				</button>
			</div>
		</div>
	);
};

export default Item;
